import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import DepartmentInformation from '@upgrade/ui-utils/constants/department-information';
import Link from '../Link';
const SupportEmail = ({
  department,
  ...props
}) => {
  const {
    email
  } = DepartmentInformation[department];
  return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    href: `mailto:${email}`
  }), email);
};
SupportEmail.propTypes = {
  department: PropTypes.string.isRequired
};
export default SupportEmail;
//# sourceMappingURL=SupportEmail.js.map